import React from "react";
import {
    formatearFecha,
    formatearFechaHora,
} from "../../../../helpers/formatearFecha";

const DatoCierre = ({ titulo, valor }) => (
    <div className="formulario-field">
        <label className="text-nowrap">{titulo}</label>
        <div className="text-nowrap mt-1">{valor}</div>
    </div>
);

// Hasta dónde llegó el cierre, de qué producto padre es y quién lo registró. El
// Excel se exporta desde aquí, con las mismas cifras que quedaron registradas
export const EncabezadoCierre = ({ hook, regresar }) => {
    const cierre = hook.cierre;

    return (
        <React.Fragment>
            <div className="cierres-mensuales__table-header align-items-center">
                <div className="formulario-fields-row">
                    <DatoCierre
                        titulo="Producto padre"
                        valor={
                            cierre
                                ? cierre.padre_producto_terminado_nombre
                                : ""
                        }
                    />
                    <DatoCierre
                        titulo="Fecha de corte"
                        valor={cierre ? formatearFecha(cierre.fecha_corte) : ""}
                    />
                    <DatoCierre
                        titulo="Registrado por"
                        valor={cierre ? cierre.nombre_usuario : ""}
                    />
                    <DatoCierre
                        titulo="Fecha de registro"
                        valor={
                            cierre
                                ? formatearFechaHora(cierre.fecha_creacion)
                                : ""
                        }
                    />
                </div>

                <div className="d-flex ml-auto gap-10">
                    <button
                        className="btn btn-outline-dark"
                        onClick={regresar}
                    >
                        Regresar
                    </button>

                    <button
                        className="btn btn-secondary"
                        onClick={hook.descargarExcel}
                        disabled={!hook.comparativo || hook.cargando}
                    >
                        Exportar a Excel
                    </button>
                </div>
            </div>

            {cierre && cierre.observaciones && (
                <div className="formulario-field">
                    <label className="formulario-field__label">
                        Observaciones
                    </label>
                    <div>{cierre.observaciones}</div>
                </div>
            )}
        </React.Fragment>
    );
};
